define("shared/utils/mavely-self-serve-window", ["exports", "moment"], function (_exports, _moment) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.mavelySelfServeDaysRemaining = mavelySelfServeDaysRemaining;
  0; //eaimeta@70e063a35619d71f0,"moment"eaimeta@70e063a35619d71f
  // Phase 3 self-serve launch date. Users with a legacy SIMP but no
  // MavelyConnection have WINDOW_DAYS from this date to self-serve into an MC
  // before enforcement disconnects the affected linkinbio blocks.
  //
  // If the launch slips, bump this constant — the warning banners drive their
  // countdown off it.
  const SELF_SERVE_LAUNCH_DATE = '2026-08-13';
  const WINDOW_DAYS = 30;
  function mavelySelfServeDaysRemaining() {
    let now = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _moment.default)();
    const deadline = (0, _moment.default)(SELF_SERVE_LAUNCH_DATE).startOf('day').add(WINDOW_DAYS, 'days');
    const remaining = deadline.diff(now.clone().startOf('day'), 'days');
    return Math.max(0, remaining);
  }
});